import { Activity } from "./class-assignment";
import { Course } from "./course";

  export class CourseOrActivity  {
    Course: Course;
    ActivityName: string;
    isCourse: boolean;
  }
